/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as TYPES from "./action-types";
const intialState = {
  loading: false,
  userDefault: null,
  rebateDropdownData: [],
  deleteCheckLogFilter: {},
  errorMessages: [],
};

const reducer = (state = intialState, action) => {
  switch (action.type) {
    case TYPES.DELETE_CHECK_LOG_LOADING:
      return { ...state, loading: action.payload };
    case TYPES.DELETE_CHECK_LOG_REBATE_PROGRAM_DATA:
      return { ...state, rebateDropdownData: action.payload };
    case TYPES.DELETE_CHECK_LOG_FILTER:
      return { ...state, deleteCheckLogFilter: action.payload };
    case TYPES.DELETE_CHECK_LOG_USERDEFAULT:
      return { ...state, userDefault: action.payload };
    case TYPES.SET_ERROR_MESSAGES:
      return { ...state, errorMessages: action.payload };
    case TYPES.DELETE_CHECK_LOG_RESET_STORE:
      return { ...intialState };
    default:
      return state;
  }
};

export default reducer;
